<template>
  <div>
    <div class="pos-booking-header">
      <div class="logo">
        <router-link to="/admin/pos/counter-checkouts">
          <div class="logo-img">
            <i class="fas fa-futbol" style="font-size:28px;"></i>
          </div>
          <div class="logo-text">Football Info</div>
        </router-link>
      </div>
      <div class="time ts-text-black" id="time">{{ time }}</div>
      <!-- <div class="nav">
        <div class="nav-item">
          <router-link to="/pos/kitchen-order" class="nav-link">
            <svg
              viewBox="0 0 16 16"
              class="nav-icon"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 0 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8zm5.48-.079V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6zm0 3.75V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141z"
              />
            </svg>
          </router-link>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'bookingHeader',
  data() {
    return {
			 time: '00:00',
		}
	},
	created(){
		this.handleStartTime();
	},
	methods: {
		posMobileSidebarToggled: function() {
			this.posMobileSidebar = !this.posMobileSidebar;
		},
		handleCheckTime: function(i) {
			if (i < 10) {
				i = '0' + i;
			}
			return i;
		},
		handleStartTime: function() {
			var today = new Date();
			var h = today.getHours();
			var m = today.getMinutes();
			var a;
			m = this.handleCheckTime(m);
			a = (h > 11) ? 'pm' : 'am';
			h = (h > 12) ? h - 12 : h;
			
			this.time = h + ':' + m + a;
			setTimeout(() => {
				this.handleStartTime();
			}, 500);
		}
  }
}
</script>